import React from 'react';

import { Box, Container } from '@iclinic/design-system';
import ComplaintsContainer from '../complaints/components/ComplaintsContainer';
import PatientHistoryContainer from '../patientHistory/components/PatientHistoryContainer';

export default () => {
  return (
    <Container maxWidth="md">
      <Box m={3} mt="116px">
        <ComplaintsContainer />
        <PatientHistoryContainer />
      </Box>
    </Container>
  );
};
